// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1802) return "static/chunks/1802-ef287bf0f8a0ace7.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 2829 ? "ArticleSelectionCarousel" : chunkId) + "." + {"1640":"bd87062932a4fa9a","2829":"b41be0c2608c4e0b","3738":"16be4db7858b1fc0","4925":"bec978a95cecf083","6218":"c153642b152caeb4"}[chunkId] + ".js";
};